export const SELECTED_INDEX = 'SELECTED_INDEX'

